module.exports = __webpack_public_path__ + "img/top-slide2.0ab36134.jpg";